<template>
    <div class="instance-container">
        <div class="template-no-data"
             v-if="baseInfo.dockerStatus == 'failure' || baseInfo.dockerStatus != 'running'">
            <noData :value="'未安装容器组件，无容器数据'"></noData>
        </div>
        <div v-else>
            <rc-table ref="rcTable"
                      :tableAttr="tableAttr" />
        </div>
    </div>
</template>

<script>
import rcTable from '@c/basic/rcTable'
import API from '@/service/api'
export default {
    name: 'container',
    props: ['baseInfo'],
    components: {
        rcTable
    },
    data () {
        return {
            tableAttr: {
                hideHead: true,
                source: {
                    type: 'get',
                    url: API.CONTAINERS,
                    params: {
                        hostId: this.baseInfo.id
                    }
                },
                columns: [
                    {
                        key: 'name',
                        title: this.$i18n.t('容器'),
                        className: 'rc-ellipsis',
                        render: (h, params) => {
                            return h('span', params.row.name + ' ' + params.row.containerId)
                        }
                    },
                    {
                        key: 'image',
                        title: this.$i18n.t('镜像'),
                        className: 'rc-ellipsis'
                    },
                    {
                        key: 'status',
                        title: this.$i18n.t('状态'),
                        className: 'rc-ellipsis'
                    }
                ]
            }
        }
    },
    methods: {
        showLinks (ports) {
            var json = JSON.parse(ports)
            var returnString = null
            json.forEach((data, index, array) => {
                if (data.PublicPort !== undefined && data.PrivatePort !== undefined) {
                    if (this.baseInfo.publicIp != null) {
                        var publicIp = 'http://' + this.baseInfo.publicIp + ':' + data.PublicPort
                    }
                    var privateIp = 'http://' + this.baseInfo.innerIp + ':' + data.PrivatePort
                    if (this.baseInfo.publicIp != null) {
                        returnString = returnString || {}
                        returnString.publicIp = publicIp
                    }
                    if (this.baseInfo.innerIp != null) {
                        returnString = returnString || {}
                        returnString.privateIp = privateIp
                    }
                }
            })
            return returnString
        },
        consoleFun (containerId, appName) {
            var ip = this.baseInfo.publicIp || this.baseInfo.innerIp
            appName = appName || (ip + '@' + containerId.substring(0, 12))
            const websshUrl = this.$store.state.app.url.WebsshUrl
            var para = btoa('hostIp=' + this.selectedPublic + '&name=' + encodeURIComponent(encodeURIComponent(this.baseInfo.instanceName)) + '&websshUrl=' + encodeURIComponent(encodeURIComponent(websshUrl)))
            window.open('/static/html/host-webssh-console.html?' + para)
        }
        // goAppDetails (id) {
        //     this.$router.push({
        //         name: 'appdetails',
        //         params: {
        //             id: id
        //         }
        //     })
        // }
    }
}
</script>

<style lang="less">
.instance-container {
    .disabledA {
        color: #ccc !important;
        cursor: not-allowed !important;
    }
}
</style>

<style lang="less" scoped>
.template-no-data {
    width: 100%;
    padding-top: 60px;
    padding-right: 30%;
    min-height: 250px;
    line-height: 250px;
    text-align: center;
    font-size: 25px;
    color: #ccc;
}
</style>
